module.exports = __webpack_public_path__ + "static/media/chance_dorsey_avatar.48289a3a.png";